// Google Ads 전환 추적 헬퍼 (AW-18396230550)
// 아래 전환 라벨은 Google Ads 대시보드에서 발급된 실제 값으로 교체해주세요.
// 위치: Google Ads > 목표 > 전환 > 각 전환 액션의 "전환 라벨"
const ADS_ID = "AW-18396230550";
const PHONE_CALL_LABEL = "PHONE_CALL_CONVERSION_LABEL";
const QUOTE_REQUEST_LABEL = "rBFZCIqzheQcEJbngMRE";

declare global {
  interface Window {
    gtag?: (...args: unknown[]) => void;
  }
}

function trackConversion(label: string) {
  if (typeof window === "undefined" || !window.gtag) return;
  window.gtag("event", "conversion", {
    send_to: `${ADS_ID}/${label}`,
  });
}

export function trackPhoneCall() {
  trackConversion(PHONE_CALL_LABEL);
}

export function trackQuoteRequest() {
  trackConversion(QUOTE_REQUEST_LABEL);
}